const makeXY = list => ({
  x: list.map(d => d.key),
  y: list.map(d => d.value),
})

export { makeXY }
